<div class="container content-main clearfix">
    <div class="row">
        <div class="col-md-12 guides">
            <iframe src="https://logilearn.logicheck.de/kundendemo-kobra-allgemein-7248717824214dfgjkdfkgjdbfgkdfgdfg/"
            allowfullscreen="allowfullscreen"
            mozallowfullscreen="mozallowfullscreen"
            msallowfullscreen="msallowfullscreen"
            oallowfullscreen="oallowfullscreen"
            webkitallowfullscreen="webkitallowfullscreen" style="margin: 50px 0 0 0; width: 100%; height: 100%;"></iframe>
        </div>
    </div>
</div>
